import { tableDefaults, renderWordBoxes } from "./defaultConfig.js";
import { hasPermission } from "../../../../app/auth.js";
import { isResolvedName } from "../../../../app/utils/deepLink.js";

export const applicationTableConfig = () => ({
    ...tableDefaults,
    columns: [
        { title: "Name", field: "name", headerFilter: "input" },
        {
            title: "Projekte",
            field: "projectId",
            widthGrow: 2,
            formatter: (cell) => {
                const value = cell.getRow().getData().projectName;
                if (!value) return "";
                const onClick = hasPermission('Projects.Read')
                    ? (name) => { window.location.hash = `#projects?col-name=${encodeURIComponent(name)}`; }
                    : undefined;
                return renderWordBoxes(String(value), onClick, isResolvedName);
            },
        },
        { title: "Beschreibung", field: "description", headerFilter: "input" },
    ],
});